import * as React from "react";

import { Button, Text } from "@fluentui/react-components";
import { ArrowRight16Regular } from "@fluentui/react-icons";
import { useLocation, useNavigate } from "react-router-dom";

import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import { useHasGivenConsent } from "hooks/useHasGivenConsent";

type AppNavigationProps = {
  pageRoute: string;
  label: string;
  disabled?: boolean;
  PageIcon: ({ isActive, disabled }) => JSX.Element;
};

export const NavItem: React.FC<AppNavigationProps> = ({ pageRoute, label, disabled, PageIcon }) => {
  const theme = useAppTheme();
  const navigate = useNavigate();
  const hasGivenConsent = useHasGivenConsent();

  const { pathname } = useLocation();

  const isActivePage = pathname === pageRoute;

  const handleNavItemClick = () => {
    navigate(pageRoute);
  };

  const isDisabled = disabled || !hasGivenConsent;

  return (
    <Button
      disabled={isDisabled}
      shape="circular"
      iconPosition="after"
      style={{
        background: isActivePage ? theme.palette.purpleLight : theme.palette.white,
        justifyContent: "space-between",
        width: "100%",
        padding: "10px 15px",
      }}
      appearance={isActivePage ? "primary" : "subtle"}
      onClick={handleNavItemClick}
      icon={
        <ArrowRight16Regular
          style={{
            color: isActivePage ? theme.palette.purpleDark : theme.palette.neutralDark,
          }}
        />
      }
    >
      <Flex align="center" $gap={"10px"}>
        <PageIcon isActive={isActivePage} disabled={disabled || !hasGivenConsent} />
        <Text
          style={{
            fontWeight: 600,
            ...(isDisabled
              ? { color: "inherit" }
              : {
                  color: isActivePage ? theme.palette.purpleDark : theme.palette.black,
                }),
            fontSize: "18px",
          }}
        >
          {label}
        </Text>
      </Flex>
    </Button>
  );
};
